import { render, staticRenderFns } from "./Qualityinspectionlabel.vue?vue&type=template&id=77529cb0&scoped=true&"
import script from "./Qualityinspectionlabel.vue?vue&type=script&lang=ts&"
export * from "./Qualityinspectionlabel.vue?vue&type=script&lang=ts&"
import style0 from "./Qualityinspectionlabel.vue?vue&type=style&index=0&id=77529cb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77529cb0",
  null
  
)

export default component.exports